// extracted by mini-css-extract-plugin
export var contactForm = "FormStyles-module--contactForm--1ef15";
export var dark = "FormStyles-module--dark--07610";
export var errorText = "FormStyles-module--errorText--08c4a";
export var formEnd = "FormStyles-module--formEnd--2bc68";
export var inFooter = "FormStyles-module--inFooter--269a7";
export var leadForm = "FormStyles-module--leadForm--02019";